import React from 'react'
import PropTypes from 'prop-types'
import ImproveBox from '../ImproveBox'
import AddButton from '../AddButton'
import getValueInUnit from '../../utilities/Data/User/getValueInUnit'
import styles from './UserImproveBox.icss'

const hasNoStatValue = (stats, attrib) => (!stats || !stats[attrib] || !stats[attrib].value || !getValueInUnit(stats[attrib]))
const showAnyStatLinks = (stats, attribs) => attribs.some(attrib => hasNoStatValue(stats, attrib))

const availableStats = ['height', 'dateOfBirth', 'weight', 'waist', 'chest', 'chestShape', 'fitPreference', 'stomachShape']

class UserImproveBox extends React.Component {
	render() {
		const { userProfile } = this.props

		return showAnyStatLinks(userProfile.statistics, availableStats) && (
			<ImproveBox text={this.context.translate('Improve your fit! Add these stats:')}>
				{hasNoStatValue(userProfile.statistics, 'height') && (
					<div className={styles.buttonLine}>
						<AddButton onClick={() => this.props.appRedirect('/editheight')} className={styles.addButton}>{this.context.translate('Add your height')}</AddButton>
					</div>
				)}
				{hasNoStatValue(userProfile.statistics, 'dateOfBirth') && (
					<div className={styles.buttonLine}>
						<AddButton onClick={() => this.props.appRedirect('/editstatistics')} className={styles.addButton}>{this.context.translate('Add your date of birth')}</AddButton>
					</div>
				)}
				{hasNoStatValue(userProfile.statistics, 'weight') && (
					<div className={styles.buttonLine}>
						<AddButton onClick={() => this.props.appRedirect('/editweight')} className={styles.addButton}>{this.context.translate('Add your weight')}</AddButton>
					</div>
				)}
				{hasNoStatValue(userProfile.statistics, 'waist') && (
					<div className={styles.buttonLine}>
						<AddButton onClick={() => this.props.appRedirect('/editwaist')} className={styles.addButton}>{this.context.translate('Add your waist measurement')}</AddButton>
					</div>
				)}
				{hasNoStatValue(userProfile.statistics, 'chest') && (
					<div className={styles.buttonLine}>
						<AddButton onClick={() => this.props.appRedirect('/editchest')} className={styles.addButton}>{this.context.translate('Add your chest circumference')}</AddButton>
					</div>
				)}
				{hasNoStatValue(userProfile.statistics, 'chestShape') && (
					<div className={styles.buttonLine}>
						<AddButton onClick={() => this.props.appRedirect('/editshape')} className={styles.addButton}>{this.context.translate('Add your chest shape')}</AddButton>
					</div>
				)}
				{hasNoStatValue(userProfile.statistics, 'fitPreference') && (
					<div className={styles.buttonLine}>
						<AddButton onClick={() => this.props.appRedirect('/editshape')} className={styles.addButton}>{this.context.translate('Add your fit tightness')}</AddButton>
					</div>
				)}
				{hasNoStatValue(userProfile.statistics, 'stomachShape') && (
					<div className={styles.buttonLine}>
						<AddButton onClick={() => this.props.appRedirect('/editshape')} className={styles.addButton}>{this.context.translate('Add your stomach shape')}</AddButton>
					</div>
				)}
			</ImproveBox>
		)
	}
}

UserImproveBox.propTypes = {
	userProfile: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	appRedirect: PropTypes.func.isRequired
}

UserImproveBox.contextTypes = {
	translate: PropTypes.func
}

export default UserImproveBox



// WEBPACK FOOTER //
// ./src/components/User/UserImproveBox.jsx